import styled, {css} from 'styled-components';

interface ContentInputProps {
  error: boolean,
}

export const ContentInput = styled.div<ContentInputProps>`
display: flex;
flex-direction: column;
background: #fff;
width: 100%;
${props =>
  props.error &&
  css`
  input {
    border: 1px solid #c53030 !important;
    color: #c53030;
    padding: 16px;
  }
`}
`

export const ContainerError = styled.div`
  display: flex;
  justify-content: flex-start;

  width: 100%;
  height: 25px;

  span {
    color: #c53030;
  }
  margin-left: 8px;
  margin-top: 8px;
`;

export const ContentInputandLabel = styled.div`
  width: 100%;

  > div {
    margin-top: 7px;
  }
`